<template>
  <div class="board" @click="showDialog">
    <img src="../../assets/board.png" alt="">
    <span>联</span>
    <span>系</span>
    <span>我</span>
    <span>们</span>
  </div>
  <div class="fzp" v-if="fzpStatus">
    <div class="close">
      <el-button class="closeFzp" type="text" @click="fzpStatus=false;">关闭</el-button>
    </div>
    <a href="https://www.qinglangtianjin.com/">
      <img src="../../assets/b1.png" alt="">
    </a>

    <a href="https://www.12377.cn/">
      <img src="../../assets/b2.png" alt="">
    </a>
    <p>
      <span>公布举报电话:18920686806</span>
      <span>公布举报邮箱:christine@inkstar.cn</span>
    </p>
  </div>
  <el-dialog
      v-model="form.show"
      title="联系方式"
      width="30%">
    <el-form :model="form" label-width="120px">
      <el-form-item label="姓名">
        <el-input placeholder="请输入姓名" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="电话">
        <el-input placeholder="请输入电话" v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="QQ">
        <el-input placeholder="请输入qq号" v-model="form.qq"></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input placeholder="请输入邮箱" v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="留言">
        <el-input v-model="form.desc" type="textarea" placeholder="请输入留言信息" />
      </el-form-item>
    </el-form>
    <template #footer>
        <span class="dialog-footer">
          <el-button @click="form.show = false">关闭</el-button>
          <el-button type="primary" @click="submit">提交</el-button>
        </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "board",
  data(){
    return{
      fzpStatus:true,
      form:{
        show:false,
        name:"",
        phone:"",
        email:"",
        qq:"",
        desc:"",
      }
    }
  },
  methods:{
    showDialog(){
      this.form.name = "";
      this.form.phone = "";
      this.form.email = "";
      this.form.qq = "";
      this.form.show = true;
    },
    submit(){
      this.form.show = false
    },
    hrefTo(){
      window.location.href='https://www.12377.cn'
    }
  }
}
</script>

<style scoped>
  .board{
    width:20px;
    position: fixed;
    z-index:1000;
    background: rgb(198,16,29);
    color:white;
    right:0;
    top:45%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding:8px 3px;
    cursor: pointer;
  }
  .board img{
    width:20px;
    height:20px;
    margin-bottom: 5px;
  }
  .fzp{
    position: fixed;
    display: flex;
    width:300px;
    flex-direction: column;
    left:0;
    background: white;
    padding:15px 10px;
    top:30%;
  }
  .fzp img{
    width:100%;
  }
  .fzp p{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .close{
    display: flex;
    justify-content: flex-end;
  }
  .closeFzp{
    width:60px;
  }
</style>